var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-calendar"},[_vm._v("ToolCalendar")])
}
var staticRenderFns = []

export { render, staticRenderFns }